module.exports = "<div class=\"spinnerBtn\" content>\n    <button track-submit={{track}} ng-click=\"submit()\" class=\"btn full\">\n        <div ng-show=\"isProcessing\" ng-class=\"{processing: isProcessing}\" class=\"spinner\"></div>\n        <div ng-hide=\"isProcessing\" class=\"text\" ng-bind-html=\"htmlContent(buttonText)\"></div>\n    </button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ../~/noop-loader!./components/xo-ui-components/src/spinner-button/template.html
// module id = ../node_modules/noop-loader/index.js!./components/xo-ui-components/src/spinner-button/template.html
// module chunks = 1